import React from 'react';
import { Form, Button } from 'tabler-react';
import toast from 'cogo-toast';
import Request from '../../shared/request';
import i18n from '../../shared/i18n';

class Exchange extends React.Component {
  state = {
    code: null,
  };

  exchange = async () => {
    if (!this.state.code) {
      toast.error(i18n.t('dash-active-placeholder'));
      return;
    }

    const result = await Request.call('activeCard', {
      code: this.state.code,
    });

    if (result) {
      toast.success(i18n.t('dash-active-success'));
      window.location.reload();
    }
  };

  render() {
    return (
      <Form.InputGroup>
        <Form.Input
          color="yellow"
          placeholder={i18n.t('dash-active-placeholder')}
          onChange={event => {
            this.setState({ code: event.target.value });
          }}
        />
        <Form.InputGroupAppend>
          <Button RootComponent="div" onClick={this.exchange} color="primary">
            {i18n.t('dash-active-btn')}
          </Button>
        </Form.InputGroupAppend>
      </Form.InputGroup>
    );
  }
}

export default Exchange;
